const {renderInfoGroups} = require("../../office/checkout/CheckoutUtil");
const OpsParentSubChange = require("../vault/OpsParentSubChange");

// TODO: Extra customization of the return for this function may be needed. If
// so, we should add extra checkoutInfo properties differentiating how cart and
// account behave in renderInfoGroups.
const renderInfoGroupsAccount = function(account, options = {}) {
	return renderInfoGroupsAccountFinished(
		OpsParentSubChange.getFinishObject(account),
		options
	);
};

const renderInfoGroupsAccountFinished = function(
	lastFinishedSCS,
	options = {}
) {
	return renderInfoGroups({
		contact: lastFinishedSCS.contact,
		creditCard: null,
		shownCC: lastFinishedSCS.shownCC,
		shipping: lastFinishedSCS.shipping,
		billing: lastFinishedSCS.billing,
		account: null,
		needsAccount: false,
		needsShipping: lastFinishedSCS.needsShipping,
		onPaypalFlow: false,

		alwaysUseFullTitle: options.alwaysUseFullTitle,
		referenceID: options.referenceID,
		accountAsGroup: options.accountAsGroup,
	});
};

module.exports = {
	renderInfoGroupsAccount,
	renderInfoGroupsAccountFinished,
};
